var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "roleInfo",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.roleInfo, rules: _vm.roles }
        },
        [
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("岗位名称")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "name" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x",
                        attrs: {
                          disabled: _vm.state != 0,
                          type: "text",
                          "auto-complete": "off"
                        },
                        model: {
                          value: _vm.roleInfo.name,
                          callback: function($$v) {
                            _vm.$set(_vm.roleInfo, "name", $$v)
                          },
                          expression: "roleInfo.name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("描述")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        staticClass: "width-2x",
                        attrs: {
                          disabled: _vm.state != 0,
                          type: "textarea",
                          rows: 2,
                          placeholder: "请输入描述"
                        },
                        model: {
                          value: _vm.roleInfo.desc,
                          callback: function($$v) {
                            _vm.$set(_vm.roleInfo, "desc", $$v)
                          },
                          expression: "roleInfo.desc"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("需要添加岗位的部门")]),
        _vm._v(" "),
        _vm.state == 0
          ? _c(
              "button",
              {
                staticClass: "swb-btn swb-btn-small",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.selectCom()
                  }
                }
              },
              [_vm._v("选择机构")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.state == 0
          ? _c(
              "button",
              {
                staticClass: "swb-btn swb-btn-small fr",
                on: { click: _vm.start }
              },
              [_vm._v("创建岗位")]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout" },
        [
          _vm.state != 0
            ? _c("el-progress", {
                attrs: {
                  "text-inside": true,
                  "stroke-width": 20,
                  percentage: _vm.percentage,
                  status: "success"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: {
                width: "100%",
                height: "430px",
                "overflow-y": "scroll"
              },
              attrs: { data: _vm.comList, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  width: "50",
                  prop: "index",
                  align: "center",
                  label: "序号"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [_c("span", [_vm._v(_vm._s(rows.$index + 1))])]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "bizUnitName", label: "业务单元" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "业务部门" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  width: "100",
                  prop: "shopFlag",
                  align: "center",
                  label: "是否门店"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(rows.row.shopFlag ? "是" : "否"))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _vm.state != 0
                ? _c("el-table-column", {
                    attrs: { prop: "state", label: "状态" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            rows.row.success
                              ? _c("span", { staticClass: "font-green" }, [
                                  _vm._v("成功")
                                ])
                              : _c("span", { staticClass: "font-red" }, [
                                  _vm._v(_vm._s(rows.row.message))
                                ])
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.state == 0
                ? _c("el-table-column", {
                    attrs: {
                      prop: "id",
                      label: "操作",
                      align: "left",
                      width: "100"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "swb-btn swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.rmoveCom(rows.$index)
                                  }
                                }
                              },
                              [_vm._v("移除")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33c83f4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33c83f4e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/authx/SaveComRoleBatch.vue
// module id = 2336
// module chunks = 1